import _defineProperty from "@babel/runtime/helpers/defineProperty";
import React from 'react';
import BlockTypes from '../../../types/BlockTypes';
export default {
  html: _defineProperty({}, BlockTypes.IMAGE, function (_ref) {
    var node = _ref.node,
        attributes = _ref.attributes;
    var url = node.getIn(['data', 'url']);
    var name = node.getIn(['data', 'name']);
    return React.createElement("figure", null, React.createElement("img", Object.assign({}, attributes, {
      alt: name || 'From Slite.com',
      src: url,
      style: {
        width: parseInt(node.getIn(['data', 'width']), 10) || 'auto'
      }
    })));
  }),
  markdown: _defineProperty({}, BlockTypes.IMAGE, function (_ref2) {
    var node = _ref2.node;
    var url = node.getIn(['data', 'url']);
    if (!url) return;
    url = url.replace(' ', '+');
    var name = node.getIn(['data', 'name']);
    return "![".concat(name || url, "](").concat(url, ")\n");
  })
};